var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",class:{text : !_vm.source, image : _vm.source}},[(_vm.source)?[_c('img',{attrs:{"src":_vm.findSource(),"alt":_vm.name}})]:_vm._e(),(!_vm.source)?[_vm._v(" "+_vm._s(_vm.findName())+" ")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }